<script>
import { mapActions, mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import FilePreviewContainer from './file-preview-container.vue'

export default {
  name: 'GeneralFilePreview',
  components: {
    FilePreviewContainer,
  },
  mixins: [baseMixin],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    filePath: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'File Preview',
    },
  },
  data: () => {
    return {
      fileData: '',
      fileDefinition: {},
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'file/isLoading',
    }),
  },
  watch: {
    show(n, o) {
      if (n) {
        this.downloadFile()
      } else {
        this.fileData = ''
        this.fileDefinition = {}
      }
    },
  },
  methods: {
    ...mapActions({
      downloadGeneralFile: 'file/downloadGeneralFile',
    }),
    async downloadFile() {
      const result = await this.downloadGeneralFile(this.filePath)

      if (!result.isSuccess) return

      this.fileData = result.data
      this.fileDefinition = {
        filePath: this.filePath,
      }
    },
  },
}
</script>

<template>
  <section>
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      persistent
      no-click-animation
      transition="dialog-bottom-transition"
      @input="$emit('update:show')"
    >
      <v-card>
        <v-container>
          <v-card-title>
            {{ title }}
            <v-btn class="ml-auto" icon @click="$emit('update:show', false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <FilePreviewContainer
              :loading="isLoading"
              :file-data="fileData"
              :file-definition="fileDefinition"
              class="mt-4"
            />
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
